const WEEK_DAYS = ['일', '월', '화', '수', '목', '금', '토'];

function formatDateAndDay(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const dayOfWeek = WEEK_DAYS[date.getDay()];
    return [`${month}.${day}`, dayOfWeek];
}

function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    date.setHours(date.getHours() - 9);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

function formatDateYYYMMDD(timestamp) {
    if (!timestamp) return '';

    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function daysUntilExpire(expireDate) {
    const today = new Date();
    const targetDate = new Date(expireDate);
    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

function addDaysToDate(date, daysToAdd) {
    const resultDate = new Date(date);
    resultDate.setDate(resultDate.getDate() + Number(daysToAdd));
    return resultDate;
}

function getLatestDate(dates) {
    const timestamps = dates.map(date => new Date(date).getTime());
    const maxTimestamp = Math.max(...timestamps);
    return new Date(maxTimestamp);
}

function isToday(dateString) {
    const today = new Date();
    const date = new Date(dateString);
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return today.getTime() === date.getTime();
}

function getTodayDate(format='-', calDay = 0) {
    const today = new Date();
    today.setDate(today.getDate() + calDay)
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');
    return `${month}${format}${day}`;
}


export { formatDateAndDay, formatTimestamp, formatDateYYYMMDD, daysUntilExpire, addDaysToDate, getLatestDate, isToday, getTodayDate };